import { readLocal, saveLocal } from './localStorageHelper';

export const saveSession = (s) => saveLocal('pasteur-session', s);
export const getSession = () => readLocal('pasteur-session', null);
